'use client';

import { FC } from 'react';
import CircledCevronUp from '../../../../../../../public/svg/circled-cevron-up.svg';
import { Tooltip } from '../../../../tooltip/tooltip';

type Properties = {
  className?: string;
};

const ScrollToTopButton: FC<Properties> = ({ className }) => {
  const handleScrollToTop = () => {
    const prefersReducedMotion =
      typeof window !== 'undefined' &&
      window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    window.scrollTo({
      top: 0,
      behavior: prefersReducedMotion ? 'auto' : 'smooth',
    });
  };

  return (
    <Tooltip className={className} content="Scroll to top">
      <button
        type="button"
        className="focus:outline-none focus-visible:ring-2 focus-visible:ring-ogn-bright-yellow focus-visible:ring-offset-2 focus-visible:ring-offset-transparent rounded-full"
        onClick={handleScrollToTop}
        aria-label="Scroll to top"
      >
        <span className="sr-only">Scroll to top</span>
        <CircledCevronUp
          className="text-[#007297] hover:text-ogn-bright-yellow transition-colors duration-500 w-[46px] h-[46px] lg:w-[62px] lg:h-[62px]"
          aria-hidden="true"
          focusable="false"
        />
      </button>
    </Tooltip>
  );
};

export { ScrollToTopButton };
